module.exports = "images/france-2.f8ec8851.png";